import { Component, HostListener, OnInit } from "@angular/core";
import { Merchant, PaymentControllerService, PaymentReq, UserControllerService } from "../../@services/gen";
import { AuthService } from "../../@services/auth.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TdDialogService } from "@covalent/core/dialogs";
import { ActivatedRoute, Router } from "@angular/router";
import { printz } from "../../@services/utils";
import { PaymentService } from "../../@services/payment.service";
import { NotificationService } from "../../@services/notification.service";
import { UserModel } from "../../@models/user.model";
import { LocalstorageService } from "../../@services/localstorage.service";
import { Payment } from "../../@services/gen/model/payment";
import { ReceiptService } from "../../@services/receipt.service";
import { FeatureService } from "../../@services/feature.service";
import { ManagerAuthService } from "../../@services/manager-auth.service";

@Component({
  selector: "app-payment-detail",
  templateUrl: "./payment-detail.component.html",
  styleUrls: ["./payment-detail.component.scss"]
})
export class PaymentDetailComponent implements OnInit {
  paymentId: number;
  payment: PaymentReq;
  user: UserModel;
  merchant: Merchant = {};
  isMobile: boolean = false;
  voidUser;
  voidRemark;
  isInclusive: boolean;

  constructor(
    private paymentService: PaymentControllerService,
    private customPaymentService: PaymentService,
    private customAuthService: AuthService,
    private sb: MatSnackBar,
    private ns: NotificationService,
    private ds: TdDialogService,
    private userService: UserControllerService,
    private route: ActivatedRoute,
    private router: Router,
    private ls: LocalstorageService,
    private customReceiptService: ReceiptService,
    private fs: FeatureService,
    private managerAuthService: ManagerAuthService,
    private featureService: FeatureService
  ) {
    this.checkIsMobile();
  }

  ngOnInit(): void {
    this.user = this.customAuthService.getUser();
    this.merchant = this.ls.getMerchant();

    let qp = this.route.snapshot.queryParams;
    this.paymentId = +qp["paymentId"];
    this.load();
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.checkIsMobile();
  }

  private checkIsMobile() {
    this.isMobile = window.innerWidth < 768; // You can adjust the threshold as needed
  }

  load() {
    let dialogRef = this.ns.showNotification({
      message: "Loading...",
      icon: "fa fa-sync",
      manualClose: true
    });

    this.paymentService.getPaymentGet(this.paymentId).subscribe((res) => {
      dialogRef.close();
      this.payment = res as any;
      this.isInclusive = this.payment.paymentOrderItems.some(x => x.inclusiveTax > 0);
    });
  }

  voidPayment(payment: Payment) {
    if (this.featureService.isFeatureEnabled("voidPermission")) {
      this.checkVoidPermission(payment);
    } else {
      this.ds
        .openConfirm({
          title: "Void Payment",
          message: "Are you sure to void this payment? This action cannot be undone"
        })
        .afterClosed()
        .subscribe((confirmed) => {
          if (confirmed) {
            let dialogRef = this.ns.showNotification({
              message: "Voiding payment...",
              manualClose: true,
              icon: "fa fa-sync"
            });
            this.voidProcess(payment);
            dialogRef.close();
          }
        });
    }
  }

  reprintReceipt() {
    let posId = this.ls.getPosId();
    for (let mvp of this.merchant.merchantVsPrinters.filter(x => x.posId === posId || !x.posId)) {
      let dialogRef = this.ns.showNotification({
        message: "Reprint receipt",
        manualClose: true,
        icon: "fa fa-sync"
      });

      if (mvp.printReceipt) {
        // chakz testing
        if (this.fs.isFeatureEnabled("receiptHTML")) {
          this.customReceiptService.getPaymentReceiptHtml(
            this.paymentId,
            mvp.printer.paperSizeType == "BIG" ? 85 : 56,
            mvp.printer.paperSizeType == "BIG" ? 570 : 380,
            (res) => {
              dialogRef.close();

              if (!res) {
                console.log("No receipt data");
                return;
              }

              printz(
                {
                  printerName: mvp.printer.printerName,
                  printerType: mvp.printer.printerType,
                  vendorId: mvp.printer.printerVendorId,
                  ipAddress: mvp.ipAddress,
                  macAddress: mvp.macAddress,
                  paperSizeType: mvp.printer.paperSizeType
                },
                [res],
                "html"
              );
            }
          );
        } else {
          this.customPaymentService.getPaymentReceipt(
            this.paymentId,
            mvp.printer.paperSizeType == "BIG" ? 45 : 32,
            (res) => {
              dialogRef.close();

              if (!res) {
                console.log("No receipt data");
                return;
              }

              printz(
                {
                  printerName: mvp.printer.printerName,
                  printerType: mvp.printer.printerType,
                  vendorId: mvp.printer.printerVendorId,
                  ipAddress: mvp.ipAddress,
                  macAddress: mvp.macAddress
                },
                [res]
              );
            }
          );
        }
      } else {
        dialogRef.close();
      }
    }
  }

  private checkVoidPermission(payment: Payment) {
    this.managerAuthService.requireManagerAuth({ requireRemark: true }).subscribe(result => {
      if (result && result.success) {
        this.voidUser = result.username;
        this.voidRemark = result.remark;
        this.voidProcess(payment);
      }
    });
  }

  voidProcess(payment: Payment) {
    if (this.voidUser) {
      payment.voidUser = this.voidUser;
    }
    if (this.voidRemark) {
      payment.voidRemark = this.voidRemark;
    }

    this.paymentService
      .voidPaymentPost({
        payment: payment as any
      })
      .subscribe((res) => {
        this.ns.showNotification({ message: "Payment has been voided" });
        this.router.navigate(["/payment-list"]);
      });
  }

}
